import React from 'react';
import { Button, DateUtils, showMessageBox, styled } from 'ps-gui';
//import Immutable from 'immutable';
import { getFormItemLabel, getPhrase } from '../../../data/phrases';

const Wrapper = styled.div`
	display: table;
`;

const EmptyMessage = styled.div`
	white-space: pre-wrap;
`;

const ItemWrapper = styled.div`
	cursor: default;
	padding: 4px 24px;
	margin: 8px;
	&.deleted {
		opacity: 0.5;
	}
	background: ${props => props.theme.tableRowBackground};
	.ps-button {
		visibility: hidden;
		color: ${props => props.theme.lightNegativeButtonColor};
	}
	&:hover {
		background: ${props => props.theme.tableRowHoverBackground};
		&:not(.deleted) {
			.ps-button {
				visibility: visible;
			}
		}
	}
	> * {
		vertical-align: middle;
	}
`;

const Label = styled.span`
	display: inline-block;
	color: ${props => props.theme.disabledTextColor};
	padding: 4px;
	font-size: 16px;
	font-weight: 700;


`;

const Value = styled.span`
	display: inline-block;
	color: ${props => props.theme.disabledTextColor};
	padding: 4px;
	font-size: 16px;
	font-weight: 400;
	margin-right: 16px;
`;

class BankId extends React.PureComponent {
	render() {
		const bi = this.props.bankIdentity;
		const fromDate = bi.get('fromDate');
		const toDate = bi.get('toDate');
		return (
			<ItemWrapper className={toDate ? 'deleted' : ''}>
				<Label>{getFormItemLabel('id')}:</Label><Value>{bi.get('sub')}</Value>
				<Label>{getFormItemLabel('name')}:</Label><Value>{bi.get('name')}</Value>
				<Label>{getFormItemLabel('email')}:</Label><Value>{bi.get('email')}</Value>
				<Label>{getFormItemLabel('phoneNumber')}:</Label><Value>{bi.get('phoneNumber')}</Value>
				<br/>
				<Label>{getFormItemLabel('createdWhen')}: </Label><Value>{DateUtils.formatDate(fromDate)}</Value>
				{
					toDate ? (
						<><Label>{getFormItemLabel('deletedWhen')}: </Label><Value>{DateUtils.formatDate(toDate)}</Value></>
					) : (
						<Button
							type="light"
							negative
							text={getPhrase('removeBankIdentity')}
							onAction={async () => {
								const dlgRes = await showMessageBox(getPhrase('reallyRemoveBankIdentity'), { type: 'confirm' });
								if (dlgRes !== 'yes') {
									return;
								}
								this.props.onDeleteBankIdentity(bi.get('id'));
							}}
						/>
					)
				}
			</ItemWrapper>
		);
	}
}

export default class BankIdTab extends React.PureComponent {
	render() {
		const bis = this.props.bankIdentities;
		if (bis) {
			return (
				<Wrapper>
					{
						bis.map((bi, index) => {
							return (
								<BankId
									key={index}
									bankIdentity={bi}
									onDeleteBankIdentity={this.props.onDeleteBankIdentity}
								/>
							);
						})
					}
				</Wrapper>
			);
		} else {
			return (
				<Wrapper>
					<EmptyMessage>
						{getPhrase('noBankIdentityConnectedToThisUserAccount')}
					</EmptyMessage>
				</Wrapper>
			);
		}
	}
}